import React from "react";
import { Box, LinearProgress } from "@mui/material";

function FullPageLoader() {
  return (
    <>
      <Box
        sx={{
          width: 1,
          flexGrow: 1,
          minHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <LinearProgress color="inherit" sx={{ width: 1, maxWidth: 360 }} />
      </Box>
    </>
  );
}

export default FullPageLoader;
